import { z } from 'zod';
const getPastApprovedParticipationsParamsSchema = z.object({
    limit: z.number().optional(),
    offset: z.number().optional(),
    orderBy: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    appliedFilters: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
});
const partialGetPastApprovedParticipationsParamsSchema = getPastApprovedParticipationsParamsSchema.omit({
    orderBy: true,
    appliedFilters: true,
});
const getPastApprovedParticipationsResponseSchema = z.object({
    shiftsMissingHours: z.number(),
    shiftParticipants: z.object({
        total: z.number(),
        rows: z.any().array(), // TODO: Change to use Zod typed columns after PLAT-2704
    }),
});
const getPastApprovedParticipationsResponseSchemaPartial = getPastApprovedParticipationsResponseSchema.omit({ shiftParticipants: true });
export const getPastApprovedParticipationsFunctionDef = {
    name: 'getPastApprovedParticipations',
    requestSchema: getPastApprovedParticipationsParamsSchema,
    responseSchema: getPastApprovedParticipationsResponseSchema,
};
